import React, { useState } from "react";
import {
  Drawer,
  Button,
  TextField,
  Typography,
  Box,
  Grid,
  IconButton,
  Divider,
  Paper,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import ShareIcon from "@mui/icons-material/Share";
import CloseIcon from "@mui/icons-material/Close";

const SocialDrawer = ({ Themecolor = "Dark" }) => {
  const theme = localStorage.getItem("theme");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedSocialBrand, setSelectedSocialBrand] = useState("");
  const [questionField, setQuestionField] = useState("");

  const handleSelectSocialBrand = (brand) => {
    setSelectedSocialBrand(brand);
    setQuestionField("");
  };

  const handlePostQuestion = () => {
    const uuid = localStorage.getItem("uuid") || "";
    const shareUrl = `https://www.paybito.com/download-app-paybito.php?uuid=${uuid}&from=exchange`;

    if (selectedSocialBrand === "Facebook") {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          shareUrl
        )}`,
        "",
        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
      );
    } else if (selectedSocialBrand === "Twitter") {
      if (questionField.trim() !== "") {
        const title = `${questionField}\n\nRespond to my question in the comments. Try out the trading platform I am using. Here is the link to sign up.`;
        window.open(
          `https://twitter.com/share?text=${encodeURIComponent(
            title
          )}&url=${encodeURIComponent(shareUrl)}`,
          "",
          "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
        );
      } else {
        alert("Please provide a valid question");
      }
    } else if (selectedSocialBrand === "Whatsapp") {
      if (questionField.trim() !== "") {
        const title = `${questionField}\n\nPlease respond to my question here. Try out the trading platform I am using. Here is the link to sign up.`;
        window.open(
          `https://api.whatsapp.com/send?text=${encodeURIComponent(
            title + "\n" + shareUrl
          )}`,
          "",
          "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
        );
      } else {
        alert("Please provide a valid question");
      }
    } else if (selectedSocialBrand === "LinkedIn") {
      window.open(
        `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          shareUrl
        )}`,
        "",
        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
      );
    }
    setSelectedSocialBrand("");
    setQuestionField("");
  };

  const handleToggleDrawer = () => {
    setSelectedSocialBrand("");
    setQuestionField("");
    setIsDrawerOpen(!isDrawerOpen);
  };

  const colors = {
    darkBg: "#24262d",
    darkText: "#c5c6c8",
    lightBg: "#f8f9fa",
    lightText: "#474d57",
  };

  const backgroundColor =
    Themecolor === "Dark" ? colors.darkBg : colors.lightBg;
  const textColor = Themecolor === "Dark" ? colors.darkText : colors.lightText;

  return (
    <Paper>
      <IconButton
        onClick={handleToggleDrawer}
        sx={{
          position: "absolute",
          right: 0,
          top: "403px",
          zIndex: 1,
          backgroundColor: theme === "dark" ? "#24262d" : "rgb(222, 222, 222)",
          color: "#c5c6c8",
          width: 34, // fixed width
          // height: 38, // fixed height
          borderRadius: "5px", // square corners
          boxShadow: `-8px 6px 4px 1px ${
            theme === "dark" ? "#0c0b0b" : "rgb(155 155 155)"
          }`,
          "&:hover": {
            backgroundColor:
              theme === "dark" ? "#3a3b3f" : "rgb(222, 222, 222)",
          },
        }}
      >
        <ShareIcon />
      </IconButton>

      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={handleToggleDrawer}
        PaperProps={{
          sx: {
            width: 320,
            backgroundColor: "background.default",
            color: textColor,
            padding: "20px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6">Share & Engage</Typography>
          <IconButton onClick={handleToggleDrawer} sx={{ color: "inherit" }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Typography variant="body2" sx={{ mb: 3 }}>
          Ask a question or share a suggestion with friends on your favorite
          social media platform.
        </Typography>

        <Grid container spacing={2} mt={1}>
          <Grid item xs={6}>
            <Button
              variant="contained"
              startIcon={<FacebookIcon />}
              onClick={() => handleSelectSocialBrand("Facebook")}
              fullWidth
              sx={{
                backgroundColor: "#3b5998",
                "&:hover": { backgroundColor: "#2d4373" },
                height: 48,
              }}
            >
              Facebook
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="contained"
              startIcon={<TwitterIcon />}
              onClick={() => handleSelectSocialBrand("Twitter")}
              fullWidth
              sx={{
                backgroundColor: "#1da1f2",
                "&:hover": { backgroundColor: "#0d8ddb" },
                height: 48,
              }}
            >
              Twitter
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="contained"
              startIcon={<WhatsAppIcon />}
              onClick={() => handleSelectSocialBrand("Whatsapp")}
              fullWidth
              sx={{
                backgroundColor: "#25d366",
                "&:hover": { backgroundColor: "#1eb851" },
                height: 48,
              }}
            >
              WhatsApp
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="contained"
              startIcon={<LinkedInIcon />}
              onClick={() => handleSelectSocialBrand("LinkedIn")}
              fullWidth
              sx={{
                backgroundColor: "#0077b5",
                "&:hover": { backgroundColor: "#005983" },
                height: 48,
              }}
            >
              LinkedIn
            </Button>
          </Grid>
        </Grid>

        {(selectedSocialBrand === "Whatsapp" ||
          selectedSocialBrand === "Twitter") && (
          <>
            <Divider sx={{ my: 3 }} />
            <Typography variant="body2" sx={{ mb: 1 }}>
              Ask a question to a friend on {selectedSocialBrand}
            </Typography>
            <TextField
              fullWidth
              value={questionField}
              onChange={(e) => setQuestionField(e.target.value)}
              placeholder="Type your question here"
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
            />
          </>
        )}

        {selectedSocialBrand === "Facebook" && (
          <Typography variant="body2" sx={{ my: 3, textAlign: "justify" }}>
            When you click the Post your question button, a Facebook dialogue
            box will open. Type the question you would like to ask to your
            friends in the dialogue box. The question will be posted to your
            Facebook page timeline.
          </Typography>
        )}

        {selectedSocialBrand === "LinkedIn" && (
          <Typography variant="body2" sx={{ my: 3, textAlign: "justify" }}>
            When you click the Post your question button, a LinkedIn dialogue
            box will open. Type the question you would like to ask to your
            network in the dialogue box. The question will be posted to your
            LinkedIn.
          </Typography>
        )}

        {selectedSocialBrand && (
          <Box sx={{ mt: 3, textAlign: "center" }}>
            <Button
              variant="contained"
              startIcon={<ShareIcon />}
              onClick={handlePostQuestion}
              sx={{
                backgroundColor: "#3b5998",
                "&:hover": { backgroundColor: "#2d4373" },
                width: "80%",
                py: 1.5,
              }}
            >
              Post your question
            </Button>
          </Box>
        )}
      </Drawer>
    </Paper>
  );
};

export default SocialDrawer;
